import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useApplicationRedirect = (
  pathname: string,
  {
    hasMentorAccount,
    application,
  }: {
    hasMentorAccount: boolean;
    application?: { services?: string[] } | null;
  }
) => {
  const history = useHistory();

  useEffect(() => {
    const redirect = () => {
      const applicationServices = application?.services ?? [];
      if (pathname === '/specialized-mentor/apply' && applicationServices.includes('government_mentorship')) {
        history.push('/specialized-mentor/update');
      } else if (pathname === '/apply' && hasMentorAccount) {
        history.push('/update');
      } else if (pathname === '/update' && !hasMentorAccount) {
        history.push('/apply');
      }
    };
    redirect();
  }, []);
};

export default useApplicationRedirect;
